module.exports = __webpack_public_path__ + "img/DM.d57c465f.png";